import { UserFavoriteContractor } from '../types/user';
import apiClient from './client';

export const addFavoriteContractor = async (contractorProfileId: number) => {
  const response = await apiClient.post('/UserFavoriteContractor', { contractorProfileId });
  return response.data;
};

export const removeFavoriteContractor = async (contractorProfileId: number) => {
  const response = await apiClient.delete(`/UserFavoriteContractor/${contractorProfileId}`);
  return response.data;
};

export const getFavoriteContractors = async (): Promise<UserFavoriteContractor[]> => {
  const response = await apiClient.get<UserFavoriteContractor[]>('/UserFavoriteContractor');
  return response.data;
};
